import { ElementType } from "react"
import styled from "styled-components"
import { Typography } from "../../typography"

export const DeprecatedMenuListButton = styled(Typography).attrs<{
  as?: ElementType
  mode: "light" | "dark"
  selected?: boolean
}>(({ as, mode, selected }) => ({
  as: as ?? "button",
  mode: mode ?? "dark",
  selected: selected ?? false,
}))`
  color: ${({ theme, mode, selected }) =>
    selected
      ? mode === "light"
        ? theme.colors.grey.$600
        : theme.colors.grey.$400
      : mode === "light"
        ? theme.colors.grey.$500
        : theme.colors.grey.$400};
  background: ${({ theme, mode, selected }) =>
    selected
      ? mode === "light"
        ? theme.colors.white
        : theme.colors.black.$1000
      : mode === "light"
        ? theme.colors.black.$100
        : theme.colors.black.$1000};
  border: 1px solid
    ${({ theme, mode, selected }) =>
      selected ? theme.colors.grey.$200 : mode === "light" ? theme.colors.black.$100 : theme.colors.black.$1000};

  font-weight: 400;
  height: 2rem;
  font-size: 0.875rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 0.5rem;
  padding: 0 0.5rem 0 0.3rem;
  justify-content: space-between;
  cursor: pointer;
  user-select: none;

  & strong {
    margin-left: 0.75rem;
  }

  &:focus {
    outline: 2px solid ${({ theme }) => theme.colors.grey.$400};
    color: ${({ theme, mode }) => (mode === "light" ? theme.colors.black.$600 : theme.colors.white)};
  }
`
